<template>
  <div>
    <el-row>
      <el-form v-model="searchForm" ref="searchForm" :inline="true" label-suffix="：" @keyup.enter.native="showData">
        <el-form-item label="产品编码">
          <el-input v-model="searchForm.PRODUCT_CODE" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <tooltip-button :disabled="Boolean(searchForm.PRODUCT_CODE)" buttonText="搜索" tipContent="请输入产品编码" @click="showData" button-type="primary">
          </tooltip-button>
        </el-form-item>
        <el-form-item>
          <downloadJsonToExcel :header="exportHeader" fileName="unpackInfo.xlsx" @click="exportData" ref="downloadJsonToExcel" text="导出"
            tip-content="请输入产品编码" :disabled="Boolean(searchForm.PRODUCT_CODE)" plain>
          </downloadJsonToExcel>
        </el-form-item>
        <el-form-item>
          <el-tooltip content="用户能够根据拆箱后SKU编码，批量导入查询被拆箱产品信息。" placement="top">
            <el-button @click="importAfterUnpacking = true" plain>导入拆箱后产品信息查询</el-button>
          </el-tooltip>
        </el-form-item>
        <el-form-item>
          <el-tooltip content="用户能够根据拆箱前SKU编码，批量导入查询拆箱后产品信息。。" placement="top">
            <el-button @click="importBeforeUnpacking = true" plain>导入拆箱前产品信息查询</el-button>
          </el-tooltip>
        </el-form-item>
      </el-form>
    </el-row>
    <el-row>
      <el-table stripe border style="margin-top: 20px" :data="tableData">
        <el-table-column label="序号" type="index"></el-table-column>
        <el-table-column label="拆箱前产品">
          <el-table-column label="编码" prop="INNER_CODE"></el-table-column>
          <el-table-column label="名称" prop="NAME"></el-table-column>
          <el-table-column label="短名称" prop="SHORT_NAME"></el-table-column>
          <el-table-column label="品牌" prop="BRAND"></el-table-column>
          <el-table-column label="规格" prop="SPECIFICATION"></el-table-column>
          <el-table-column label="单位" prop="TYPE_UNIT"></el-table-column>
          <el-table-column label="说明" prop="DESCRIPTION"></el-table-column>
          <el-table-column label="状态" prop="CAN_USE"></el-table-column>
        </el-table-column>
      </el-table>
    </el-row>

    <el-dialog :visible.sync="importDialog" :title="dialogTitle" width="400px" center @close="closeImportDialog">
      <el-form ref="importForm" :model="importForm" size="small" :rules="rules">
        <el-form-item prop="EXCEL_FILE">
          <limit-upload class="upload-demo" action="/uploadFile" ref="limitUpload" :on-success="handleSuccess" :on-remove="handleRemove"
            :name="importForm.name" :file-list="importForm.fileList" accept=".xls,.xlsx">
            <el-button type="primary">点击上传</el-button>
          </limit-upload>
        </el-form-item>
        <p @click="downloadTemplate" style="color: #409eff; margin-top: 20px; cursor: pointer">
          点击下载导入模板
        </p>
      </el-form>
      <div slot="footer" style="text-align: center">
        <el-button class="operate-btn" @click="closeImportDialog">取消</el-button>
        <el-button class="operate-btn" @click="submitImport">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import http from '@/assets/common/http';

export default {
  data() {
    return {
      tableData: [],
      searchForm: {},
      showStatusLable: ['禁用', '在用'],
      exportHeader: {
        INNER_CODE: '编码',
        NAME: '名称',
        SHORT_NAME: '短名称',
        BRAND: '品牌',
        SPECIFICATION: '规格',
        TYPE_UNIT: '单位',
        DESCRIPTION: '说明',
        CAN_USE: '状态',
      },
      importAfterUnpacking: false,
      importBeforeUnpacking: false,
      importForm: {
        name: 'tmp',
        fileList: [],
        EXCEL_FILE: '',
      },
      importDialog: false,
      rules: {
        EXCEL_FILE: [
          { required: true, message: '请上传文件', trigger: 'change' },
        ],
      },
    };
  },
  watch: {
    importAfterUnpacking(newV, oldV) {
      if (newV) this.importDialog = newV;
    },
    importBeforeUnpacking(newV, oldV) {
      if (newV) this.importDialog = newV;
    },
    importDialog(newV, oldV) {
      if (!newV) {
        this.importAfterUnpacking = newV;
        this.importBeforeUnpacking = newV;
      }
    },
  },
  computed: {
    dialogTitle() {
      if (this.importAfterUnpacking) return '导入拆箱后产品信息查询';
      if (this.importBeforeUnpacking) return '导入拆箱前产品信息查询';
      return '';
    },
    tmpUrl() {
      if (this.importAfterUnpacking) return this.$util.getURLLocalHost('/file/templates/查询拆箱前产品.xlsx');
      if (this.importBeforeUnpacking) return this.$util.getURLLocalHost('/file/templates/查询拆箱后产品.xlsx');
      return '';
    },
  },
  created() { },
  methods: {
    submitImport() {
      this.$refs.importForm.validate((valid) => {
        if (valid) {
          let params = {};
          if (this.importAfterUnpacking) {
            params = {
              SERVICE_ID: '10200',
              OTYPE: 12,
              EXCEL_FILE: this.importForm.EXCEL_FILE,
            };
          }
          if (this.importBeforeUnpacking) {
            params = {
              SERVICE_ID: '10200',
              OTYPE: 13,
              EXCEL_FILE: this.importForm.EXCEL_FILE,
            };
          }
          http.post(params).then((res) => {
            if (res[0]) {
              window.open(this.$util.getURLLocalHost(res[0].FILE_URL));
            }
            this.closeImportDialog();
          }).catch((err) => {
            this.$message.show({ text: err, type: 'error' });
          });
        }
      });
    },
    closeImportDialog() {
      this.handleRemove();
      this.importDialog = false;
    },
    downloadTemplate() {
      if (this.tmpUrl) window.open(this.tmpUrl);
    },
    handleSuccess(response, file, fileList) {
      this.importForm.EXCEL_FILE = response.file_name;
    },
    handleRemove(file, fileList) {
      this.$refs.limitUpload.$refs.upload.clearFiles();
      this.$refs.importForm.resetFields();
    },
    exportData() {
      this.queryData().then((res) => {
        this.$refs.downloadJsonToExcel.download(res.map((item) => ({
          ...item,
          INNER_CODE: String(item.INNER_CODE),
          CAN_USE: this.showStatusLable[item.CAN_USE],
        })), [30, 30, 20, 20, 20, 20, 20, 20]);
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    showData() {
      this.queryData().then((res) => {
        this.tableData = res.map((item) => ({ ...item, CAN_USE: this.showStatusLable[item.CAN_USE] }));
        this.totalNum = res.length;
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    queryData(data = {}) {
      const params = {
        SERVICE_ID: '10200',
        OTYPE: 11,
        ...this.searchForm,
        ...data,
      };

      return http.post(params);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/SKUManage/unpackInfo.vue